import LottoOdd from '@core/models/lotto/LottoOdd.ts';

export default class LottoSystem {
    id: number;
    combinationCount: number | null = null;
    name: string = '';
    isSelected: boolean;

    constructor(id: number, isSelected: boolean = false) {
        this.id = id;
        this.isSelected = isSelected;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/lottoBetSlip/LottoSystem.ts